<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <div
      class="mb-4 flex shrink-0 items-center justify-between space-x-4"
    >
      <PageTitle> Sales Summary </PageTitle>
      <button
        type="button"
        aria-label="Close sales summary"
        class="shrink-0 rounded p-2"
        @click="emit('close')"
      >
        <IconX class="size-6" />
      </button>
    </div>
    <div class="relative flex min-h-0 flex-col">
      <div
        ref="scrollContainer"
        class="min-h-0 overflow-auto p-1"
      >
        <pre
          ref="reportContent"
          class="mx-auto whitespace-pre rounded-lg bg-background p-4 font-mono text-sm ring-1 ring-background-fg/10"
          >{{ report }}</pre
        >
      </div>
      <div
        v-if="!arrivedState.top"
        aria-hidden="true"
        class="pointer-events-none absolute inset-x-1 top-0 h-4 bg-gradient-to-b from-background-fg/20 to-transparent"
      />
      <div
        v-if="!arrivedState.bottom"
        aria-hidden="true"
        class="pointer-events-none absolute inset-x-1 bottom-0 h-4 bg-gradient-to-t from-background-fg/20 to-transparent"
      />
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { useResizeObserver, useScroll } from "@vueuse/core"

const props = defineProps<{
  isOpen: boolean
  report: string
}>()

const scrollContainer = useTemplateRef("scrollContainer")
const reportContent = useTemplateRef("reportContent")
const { arrivedState, measure } = useScroll(scrollContainer)

// Recalculate scroll state when containers change size, or when content changes.
useResizeObserver([scrollContainer, reportContent], measure)
watch(
  () => [props.isOpen, props.report],
  async () => {
    await nextTick() // Need DOM to update before recalculating scroll state.
    measure()
  }
)

const emit = defineEmits<{
  (event: "close"): void
}>()
</script>
